var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStopwatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.15991C11.7239 8.15991 11.5 8.37482 11.5 8.63991V13.9199C11.5 14.185 11.7239 14.3999 12 14.3999H17.5C17.7761 14.3999 18 14.185 18 13.9199C17.9967 10.7401 15.3123 8.16309 12 8.15991Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.527 8.02466C19.4379 8.11011 19.4289 8.24585 19.506 8.34155C22.1482 11.6145 22.166 16.1843 19.5492 19.4761C16.9324 22.7678 12.336 23.9575 8.35027 22.3745C4.3645 20.7917 1.98692 16.8325 2.55733 12.728C3.12773 8.62354 6.50337 5.40112 10.782 4.87671C10.9069 4.86182 11.0005 4.75952 11 4.63867V2.15991C11 2.02734 10.8881 1.91992 10.75 1.91992H9C8.44771 1.91992 8 1.49023 8 0.959961C8 0.429688 8.44771 0 9 0H15C15.5523 0 16 0.429688 16 0.959961C16 1.49023 15.5523 1.91992 15 1.91992H13.25C13.1835 1.91992 13.1198 1.94531 13.0729 1.99072C13.026 2.03589 12.9997 2.09717 13 2.16089V4.63867C13 4.75952 13.0933 4.86133 13.218 4.87671C14.8791 5.08301 16.4532 5.70947 17.779 6.69214C17.8784 6.76562 18.0191 6.75708 18.108 6.67212L19.764 5.08228C20.0151 4.83276 20.3869 4.73267 20.7365 4.82056C21.0861 4.9082 21.3592 5.17041 21.4507 5.5061C21.5422 5.8418 21.438 6.19873 21.178 6.4397L19.527 8.02466ZM4.5 13.9199C4.5 17.8965 7.85786 21.1199 12 21.1199C16.1403 21.1157 19.4956 17.8948 19.5 13.9199C19.5 9.9436 16.1421 6.71997 12 6.71997C7.85786 6.71997 4.5 9.9436 4.5 13.9199Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopwatch);
export default __webpack_public_path__ + "static/media/stopwatch.74913ed9.svg";
export { ForwardRef as ReactComponent };